if (!customElements.get("images-scrolling-text")) {
  customElements.define(
    "images-scrolling-text",
    class ImagesScrollingText extends HTMLElement {
      constructor() {
        super();
        this.images = this.querySelectorAll(".wt-parallax__img");
        this.items = this.querySelectorAll(".wt-images-scrolling-text__text > div");
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      makeOneVisible(){
        const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            console.log("Element w połowie ekranu:", entry.target.id);

            const number = entry.target.id.split("_")[1]; 
            const img_id = `image_${number}`;
            const text_id = `text_${number}`;
            document.querySelectorAll('[id^="image_"]').forEach(img => {
              img.style.opacity = '0';
            });
            document.querySelectorAll('[id^="text_"]').forEach(text => {
              text.style.opacity = '0.5';
            });
            const image = document.getElementById(img_id);
            if (image) {
              image.style.opacity = '1';
            }
            const text = document.getElementById(text_id);
            if (text){
              text.style.opacity = '1'
            }
          }
        });
      }, {
        root: null, 
        rootMargin: "-50% 0px -40% 0px", 
        threshold: 0 
      });

      document.querySelectorAll(".wt-images-scrolling-text__text > div").forEach(el => observer.observe(el)); 
      }

      onScroll() {
        // const container = this.querySelector('.wt-images-scrolling-text__image'); // kontener sticky
        // const containerRect = container.getBoundingClientRect();

        // if (containerRect.top < 0 || containerRect.bottom > window.innerHeight) {
        //   return;
        // }

        // const centerY = window.innerHeight / 2;

        // this.items.forEach((item, i) => {
        //   const rect = item.getBoundingClientRect();
        //   const elementCenter = rect.top + rect.height / 2;
        //   const distanceFromCenter = Math.abs(elementCenter - centerY);

        //   const maxDistance = window.innerHeight / 2;
        //   const opacity = 1 - Math.min(distanceFromCenter / maxDistance, 1);

        //   item.style.opacity = opacity;
        // });
      }

      init() {
        this.makeOneVisible();
        window.addEventListener('scroll', this.onScroll);
        this.onScroll(); 
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }
    },
  );
}
